module.exports = __webpack_public_path__ + "static/media/dosco.e2bac28f.png";